// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2tr9w","calendarButtons":"ClockData_calendarButtons__3NXOU"};